import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CashBackToggleComponent } from './cash-back-toggle.component';
import { FGBSharedModule } from '@fgb/portal-component-library/src/lib/shared';
import { FormsModule } from '@angular/forms';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

@NgModule({
  declarations: [CashBackToggleComponent],
  imports: [
    CommonModule,
    FormsModule,
    BrowserAnimationsModule,
    FGBSharedModule
  ],
  exports: [CashBackToggleComponent],
})
export class CashBackToggleModule {}
